import { module } from 'angular';
import templateBuilderPhoneNumberDisplay from './builder/display.html';
import templateBuilderPhoneNumberValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/phone-number/display.html', templateBuilderPhoneNumberDisplay);
	$templateCache.put('kform/components/phone-number/validate.html', templateBuilderPhoneNumberValidate);
});
